import React, { useState } from 'react'
import TextField from '@mui/material/TextField'
// import DatePicker from '../../../common/DatePickerMUI'
import SelectField from '../../../CommonComponents/SelectMUI'
import { penaltyFeeType, processingFeeAtDisbursment, processingFeeType, typeOfInterestRate } from '../../../CommonUtils'
const approvalTypeArr = [
    { code: true, name: 'Custom' },
    { code: false, name: 'Pre-Defined' }
]



const Approve = ({ validationMsgfirst, validationMsg, approveData, approveDataHandlernew, amount, emi, emiHandler, amountHandler,
    approveHandler, close, approveDate, approveDateHandler, repaymentDate, repaymentDateHandler, bankNameHandler, bankName, matchingData, matchingDiv
    , nbfcName, matchingDataNbfc, matchingDivNbfc, nbfcNameHandler, disableNbfc, disableBank, message }) => {

    return (
        <div className="background-blur-admin" >
            <div className="popup-admin " style={{ width: '55%', height: 'auto' }}>
                <i className='fa fa-close' onClick={() => close()} style={{ float: 'right', color: 'red', marginTop: '-20px', cursor: 'pointer' }}></i>
                <div className='row'>
                    <div className='col-sm-4 col-xs-12' style={{ marginTop: '10px' }} >
                        <TextField
                            label="Amount"
                            variant="outlined"
                            value={amount}
                            type="number"
                            onChange={e => amountHandler(e)}
                            size="small"
                            style={{ width: '100%' }}
                        />
                        <span className='text-center text-danger'>{message && message.field === 'amountHelp' ? message.msg : ''}</span>

                    </div>
                    <div className='col-sm-4 col-xs-12' style={{ marginTop: '10px' }}>
                        <TextField
                            label="Emi"
                            variant="outlined"
                            value={emi}
                            type="number"
                            onChange={e => emiHandler(e)}
                            size="small"
                            style={{ width: '100%' }}
                        />
                        <span className='text-center text-danger'>{message && message.field === 'emiHelp' ? message.msg : ''}</span>

                    </div>
                    <div className='col-sm-4 col-xs-12'>
                        <TextField
                            label="Approved Date"
                            type='date'
                            variant="outlined"
                            // format={'MM/dd/yyyy'}
                            value={approveDate}
                            name="approvedate"
                            size="small"
                            onChange={(e) => approveDateHandler(e)}
                            required={true}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-5 col-xs-12 mt-3'>
                        <TextField
                            style={{ width: '100%' }}
                            label="Bank Name"
                            variant="outlined"
                            name="bankName"
                            id="bankName"
                            disabled={disableBank}
                            type="text"
                            value={bankName}
                            onChange={e => approveDataHandlernew(e, 'bankName')}
                            size="small"
                        />
                        {
                            bankName && matchingData && matchingData.length > 0 && matchingDiv ?
                                <ul className="designation-list" style={{ zIndex: '9999' }}>
                                    {
                                        matchingData.map((data, i) => {
                                            return (
                                                <li key={i} value={data} onClick={() => bankNameHandler(data)} >{data.bank_name}</li>
                                            )
                                        })
                                    }
                                </ul>
                                : bankName && matchingData.length == 0 && message && message.field !== 'bankHelp' ?
                                    <ul className="designation-list" style={{ zIndex: '9999' }}>
                                        {console.log("No data")}
                                        <li value="No data found!" >No data found!</li>
                                    </ul> : ""}
                        <span className='text-center text-danger'>{message && message.field === 'bankHelp' ? message.msg : ''}</span>

                    </div>
                    <div className='col-sm-2 col-xs-12 mt-3 text-center'>
                        <h5 className='mt-2'>OR</h5>
                    </div>
                    <div className='col-sm-5 col-xs-12 mt-3'>
                        <TextField
                            style={{ width: '100%' }}
                            label="Nbfc Name"
                            variant="outlined"
                            name="nbfcName"
                            id="nbfcName"
                            type="text"
                            value={nbfcName}
                            disabled={disableNbfc}
                            onChange={e => approveDataHandlernew(e, 'nbfcName')}
                            size="small"
                        />
                        {
                            nbfcName && matchingDataNbfc && matchingDataNbfc.length > 0 && matchingDivNbfc ?
                                <ul className="designation-list">
                                    {
                                        matchingDataNbfc.map((data, i) => {
                                            return (
                                                <li key={i} value={data} onClick={() => nbfcNameHandler(data)} >{data.nbfc_name}</li>
                                            )
                                        })}

                                </ul>
                                : nbfcName && matchingDataNbfc.length == 0 && message && message.field !== 'nbfcHelp' ?
                                    <ul className="designation-list" style={{ zIndex: '9999' }}>
                                        <li value="No data found!" >No data found!</li>
                                    </ul> : ""}
                        <span className='text-center text-danger'>{message && message.field === 'nbfcHelp' ? message.msg : ''}</span>

                    </div>

                </div>
                <div className='row'>
                    {/* <div className='col-sm-4 col-xs-12' style={{ marginTop: '10px' }}>
                        <DatePicker
                            label="Repayment Date"
                            format={'MM/dd/yyyy'}
                            value={repaymentDate}
                            name="repaymentdate"
                            size="small"
                            onChange={(e) => repaymentDateHandler(e)}
                            required={true}
                        />
                    </div> */}
                    <div className='col-sm-4 col-xs-12' style={{ marginTop: '10px' }}>
                        <SelectField
                            label={'Approval Type'}
                            onChange={e => approveDataHandlernew(e, 'approvalType')}
                            name='approvalType'
                            // value={this.state.calculatorData.penaltyFeeType}
                            data={approvalTypeArr}
                            size={'small'}
                            required={true}
                            id='approvalType'
                        />
                        <span className='text-center text-danger'>{message && message.field === 'approvalHelp' ? message.msg : ''}</span>
                        <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'approvalType' ? validationMsg.msg : ''}</span>
                    </div>
                    {approveData && approveData.approvalType === true ?
                        <div className='col-sm-4 col-xs-12' style={{ marginTop: '10px' }}>
                            <SelectField
                                label={'Processing Fee At Disbursment'}
                                onChange={e => approveDataHandlernew(e, 'processingFeeAtDisbursment')}
                                name='processingFeeAtDisbursment'
                                data={processingFeeAtDisbursment}
                                size={'small'}
                                id="processingFeeAtDisbursment"
                                required={true}
                            />
                            <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'processingFeeAtDisbursment' ? validationMsg.msg : ''}</span>

                        </div>
                        : ""}
                </div>
                {approveData && approveData.approvalType === true ?

                    <div className='row' >

                        <div className='col-sm-4 col-xs-12' style={{ marginTop: '10px' }}>
                            <SelectField
                                label={'Processing Fee Type'}
                                onChange={e => approveDataHandlernew(e, 'processingFeeType')}
                                data={processingFeeType}
                                size={'small'}
                                required={true}
                                name='processingFeeType'
                                id='processingFeeType'

                            />
                            <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'processingFeeType' ? validationMsg.msg : ''}</span>

                        </div>
                        <div className='col-sm-4 col-xs-12'>
                            <TextField style={{ width: '100%' }}
                                onChange={e => approveDataHandlernew(e, 'processingFee')}
                                label={'Processing Fee in ₹'}

                                // label={this.state.calculatorData.processingFeeType === "variableProcessingFee" ? 'Processing Fee in %' : 'Processing Fee in ₹'}
                                variant="filled"
                                // value={this.state.calculatorData.processingFee}
                                name='processingFee'
                                id='processingFee'

                            />
                            <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'processingFee' ? validationMsg.msg : ''}</span>

                        </div>


                        <div className='col-sm-4 col-xs-12' style={{ marginTop: '10px' }}>
                            <SelectField
                                label={'Type Of Interest Rate'}
                                onChange={e => approveDataHandlernew(e, 'typeOfInterestRate')}
                                name='typeOfInterestRate'
                                id='typeOfInterestRate'

                                // value={this.state.calculatorData.typeOfInterestRate}
                                data={typeOfInterestRate}
                                size={'small'}
                                required={true}
                            />
                            <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'typeOfInterestRate' ? validationMsg.msg : ''}</span>

                        </div>

                    </div>
                    : ""}

                {approveData && approveData.approvalType === true ?

                    <div className='row'>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField
                                onChange={e => approveDataHandlernew(e, 'rateOfInterest')}
                                name='rateOfInterest'
                                style={{ width: '100%' }}
                                label="Rate Of Interest in %"
                                variant="filled"
                                id='rateOfInterest'

                            //  value={this.state.calculatorData.rateOfInterest} 
                            //  onChange={(e) => this.handleChange(e, 'rateOfInterest')}
                            />
                            <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'rateOfInterest' ? validationMsg.msg : ''}</span>

                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '18px' }}>
                            <SelectField
                                label={'Penalty Fee Type'}
                                onChange={e => approveDataHandlernew(e, 'penaltyFeeType')}
                                name='penaltyFeeType'
                                id='penaltyFeeType'
                                data={penaltyFeeType}
                                size={'small'}
                                required={true}
                            />
                            <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'penaltyFeeType' ? validationMsg.msg : ''}</span>

                        </div>

                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                            <TextField style={{ width: '100%' }}
                                onChange={e => approveDataHandlernew(e, 'penaltyFee')}
                                name='penaltyFee'
                                id='penaltyFee'

                                label={"Penalty Fee in ₹"}
                                //  label={this.state.calculatorData.penaltyFeeType === 'variableRateOfPenalty' ? "Penalty Fee in %" : "Penalty Fee in ₹"}
                                variant="filled"
                            />
                            <span className='text-center text-danger'>{validationMsg && validationMsg.field === 'penaltyFee' ? validationMsg.msg : ''}</span>

                        </div>
                    </div>
                    : ""}


                <div className='mt-3 row text-center'>
                    <div className="col-sm-12 col-xs-12 ">
                        <h5 className=' text-danger'>{validationMsgfirst ? validationMsgfirst : ''}</h5>
                        <br />
                        <button className="cred-btn" onClick={e => approveHandler()}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Approve;